import type { MapaCargoSecao } from '@/components/Configuracao/mapaCargos/mapaCargosTypes'

type Props = {
  secoes: MapaCargoSecao[]
}

export function MapaCargosEscopoView({ secoes }: Props) {
  return (
    <div className='space-y-4'>
      {secoes.map((secao) => (
        <article
          key={secao.id}
          className='rounded-xl border border-[var(--glass-border)] bg-[var(--glass-bg)] p-4'
        >
          <h4 className='text-sm font-bold uppercase tracking-wide text-[var(--text-primary)]'>
            {secao.titulo}
          </h4>
          <ul className='mt-3 space-y-2'>
            {secao.atividades.map((atividade, index) => (
              <li
                key={`${secao.id}-${index}`}
                className='flex gap-2 text-[13px] leading-relaxed text-[var(--text-secondary)]'
              >
                <span className='mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-[var(--brand-primary)]' />
                <span>{atividade}</span>
              </li>
            ))}
          </ul>
        </article>
      ))}
    </div>
  )
}
